var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 77,
    viewBox: "0 0 90 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Reduced radiation exposure-01",
    clipPath: "url(#clip0_887_4706)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.6001 38.1004V6.10039H51.3001C52.0001 6.10039 52.7001 5.80039 53.1001 5.30039C53.6001 4.80039 53.9001 4.20039 53.9001 3.50039C53.9001 2.10039 52.7001 0.900391 51.3001 0.900391H11.3001C8.6001 0.900391 6.5001 3.10039 6.5001 5.70039V72.3004C6.5001 74.3004 8.2001 76.0004 10.2001 76.0004H81.2001C82.5001 76.0004 83.6001 74.9004 83.6001 73.6004V64.2004H55.3001C53.9001 64.2004 52.5001 64.8004 51.6001 65.8004L47.0001 70.7004H15.3001V48.7004",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M70.6 40.9004H29C25.4 40.9004 22.5 43.8004 22.5 47.4004C22.5 48.7004 23.6 49.8004 24.9 49.8004H83.5V43.3004C83.5 42.0004 82.4 40.9004 81.1 40.9004H76",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M48.7002 6.09961H29.9002V9.59961C29.9002 11.1996 31.2002 12.4996 32.8002 12.4996H45.8002C47.4002 12.4996 48.7002 11.1996 48.7002 9.59961V6.09961Z",
    fill: "#F69A4D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M33.9 49.7002H83.5V64.3002H37.2C35.4 64.3002 33.9 62.8002 33.9 61.0002V49.7002Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M48.7002 6.09961H29.9002V9.59961C29.9002 11.1996 31.2002 12.4996 32.8002 12.4996H45.8002C47.4002 12.4996 48.7002 11.1996 48.7002 9.59961V6.09961Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M51 24.5C44.5 31 34.1 31 27.6 24.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M47.8999 21.2998C43.1999 25.9998 35.4999 25.9998 30.7999 21.2998",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M44.7002 18.2002C41.7002 21.2002 36.9002 21.2002 33.9002 18.2002",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M33.8999 49.6998H62.3999L60.4999 46.5998C59.9999 45.7998 59.0999 45.2998 58.1999 45.2998H36.2999C34.9999 45.2998 33.9999 46.2998 33.9999 47.5998V49.6998H33.8999Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M39.7002 45.2998V49.6998",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M45 45.2998V49.6998",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M50.2998 45.2998V49.6998",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M55.6001 45.2998V49.6998",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M14.5 43.5C12.567 43.5 11 41.933 11 40C11 38.067 12.567 36.5 14.5 36.5C16.433 36.5 18 38.067 18 40C18 41.933 16.433 43.5 14.5 43.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_887_4706"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 77,
    fill: "white",
    transform: "matrix(-1 0 0 1 90 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon04);
export default __webpack_public_path__ + "static/media/icon04.74c996f70b84b28593474b897a407929.svg";
export { ForwardRef as ReactComponent };